import React from 'react';
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import { BrowserTracing } from '@sentry/tracing';

import App from './App';
//import { worker } from 'mocks/worker';
import reportWebVitals from './reportWebVitals';

import './config/i18n';
import './assets/css/main.css';
import './assets/css/Brand.css';
// import './assets/css/general.scss';

const EVENTS_TO_IGNORE = ['ResizeObserver'];
const TRACING_RATE = 1.0;
const ERROR_SAMPLE_RATE = 1.0;

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY,
  integrations: [new BrowserTracing()],
  environment: process.env.REACT_APP_ENV,
  ignoreErrors: EVENTS_TO_IGNORE,
  release: process.env.REACT_APP_VERSION,
  sampleRate: ERROR_SAMPLE_RATE,
  tracesSampleRate: TRACING_RATE,
  defaultIntegrations: false,
});

if (process.env.NODE_ENV === 'development') {
  //worker.start();
}

const container = document.getElementById('root');
if (container) {
  const rootContainer = createRoot(container);
  rootContainer.render(
    // <React.StrictMode>
    <App />
    // </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
